import { Outlet, useLocation, useNavigate } from 'react-router';

import { clsx } from 'clsx';

import { RealtimeProvider } from 'providers/RealtimeProvider';

import { ProfileMenu } from './components';
import { StudentModeratorCommentBanner } from './components/StudentModeratorCommentBanner';
import { StudentProfileCompletionBanner } from './components/StudentProfileCompletionBanner';
import classes from './Profile.module.scss';

export const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isNewTask = /^\/profile\/details\/task\/?$/.test(location.pathname);
  const activeSection = isNewTask
    ? 'tasks'
    : location.pathname.split('/')[2] || 'profile';
  const handleChange = (section: string) => {
    navigate(`/profile/${section === 'profile' ? '' : section}`);
  };
  const hideMenu = location.pathname.startsWith('/profile/details') && !isNewTask;
  const isProfileIndex =
    location.pathname === '/profile' || location.pathname === '/profile/';
  const isChat =
    location.pathname.startsWith('/profile/chats') ||
    /^\/profile\/details\/[^/]+\/chats/.test(location.pathname);

  return (
    <div className={classes.container}>
      <RealtimeProvider>
        <div className={clsx(classes.root, isChat && classes['root--chat'])}>
          {!hideMenu && (
            <ProfileMenu activeSection={activeSection} onChange={handleChange} />
          )}
          <div className={classes['profile-content']}>
            <StudentProfileCompletionBanner />
            {!isProfileIndex && <StudentModeratorCommentBanner />}
            <Outlet />
          </div>
        </div>
      </RealtimeProvider>
    </div>
  );
};
